import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServicioAutenticacion } from '../auth/auth.service';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import $ from 'jquery';
import { languageSettings } from '../lenguajeDatatable';

@Component({
  selector: 'app-incongruencias',
  templateUrl: './incongruencias.component.html',
  styleUrls: ['./incongruencias.component.css']
})
export class IncongruenciasComponent implements OnInit {
  rows: any[] = [];

  constructor(
    private http: HttpClient,
    private servicioAutenticacion: ServicioAutenticacion,
    private apiSrv: ApiService,
    private loadingSrv: LoadingService,
  ) {}

  ngOnInit(): void {
    this.cargarIncongruencias();
  }

  cargarIncongruencias() {
    this.apiSrv.obtenerIncongruencias().subscribe(data => {
      this.rows = data;
      this.inicializarTablaIncongruencias();
    });
  }

  inicializarTablaIncongruencias(): void {
    const tableBody = this.rows.map(row => [
      row.documento,
      `${row.nombre} ${row.apellido}`,
      row.cuil,
      row.cuilTitular,
      row.activo === 1 ? 'Activo' : 'Baja'
    ]);

    $('#tablaIncongruencias').DataTable({
      data: tableBody,
      language: languageSettings,
      columns: [
        { title: "Documento" },
        { title: "Nombre y Apellido" },
        { title: "CUIL" },
        { title: "CUIL Titular" },
        { title: "Estado" }
      ],
    });
  }
}